<script setup lang="ts">
import { RestoreHistoryIcon } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <Icon :path="RestoreHistoryIcon" :size="24" fill="#005FE8" />
</template>
